'use client';

import * as React from 'react';
import { isAutogeneratedRowNode } from "../rows/gridRowsUtils.js";

/**
 * Default implementation of the cell editable condition hook
 */
export const useIsCellEditable = () => React.useCallback(params => !isAutogeneratedRowNode(params.rowNode), []);